export default __webpack_public_path__ + "static/media/alabamaMap.7262a554.png";